// RESET
export const RESET = 'RESET';

// FETCH_COMPANY
export const FETCH_COMPANY_PENDING = 'FETCH_COMPANY_PENDING';
export const FETCH_COMPANY_FULFILLED = 'FETCH_COMPANY_FULFILLED';
export const FETCH_COMPANY_ERROR = 'FETCH_COMPANY_ERROR';

// STORE_COMPANY
export const STORE_COMPANY_PENDING = 'STORE_COMPANY_PENDING';
export const STORE_COMPANY_FULFILLED = 'STORE_COMPANY_FULFILLED';
export const STORE_COMPANY_ERROR = 'STORE_COMPANY_ERROR';

// FETCH_LOCATION
export const FETCH_LOCATION_PENDING = 'FETCH_LOCATION_PENDING';
export const FETCH_LOCATION_FULFILLED = 'FETCH_LOCATION_FULFILLED';
export const FETCH_LOCATION_ERROR = 'FETCH_LOCATION_ERROR';

// CHECK_COMPANY_PROFILE
export const CHECK_COMPANY_PROFILE_PENDING = 'CHECK_COMPANY_PROFILE_PENDING';
export const CHECK_COMPANY_PROFILE_FULFILLED = 'CHECK_COMPANY_PROFILE_FULFILLED';
export const CHECK_COMPANY_PROFILE_ERROR = 'CHECK_COMPANY_PROFILE_ERROR';

// FETCH_CONTACT_PERSON
export const FETCH_CONTACT_PERSON_PENDING = 'FETCH_CONTACT_PERSON_PENDING';
export const FETCH_CONTACT_PERSON_FULFILLED = 'FETCH_CONTACT_PERSON_FULFILLED';
export const FETCH_CONTACT_PERSON_ERROR = 'FETCH_CONTACT_PERSON_ERROR';

// STORE_CONTACT_PERSON
export const STORE_CONTACT_PERSON_PENDING = 'STORE_CONTACT_PERSON_PENDING';
export const STORE_CONTACT_PERSON_FULFILLED = 'STORE_CONTACT_PERSON_FULFILLED';
export const STORE_CONTACT_PERSON_ERROR = 'STORE_CONTACT_PERSON_ERROR';
